export enum CountryEnum {
  Brasil    = 1,
  Argentina = 2,
  Equador   = 3,
  Peru      = 4,
  Colombia  = 5,
  Uruguai   = 6,
  Chile     = 7,
  RepublicaDominicana = 8,
}

